

import config from '@/config/index';

// 本地存储封装
class Cookie {
  constructor() {
    this.cookie = document.cookie;
  }
  set(name, value) {
    const Days = config.cookieDate;
    const exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/';
  }

  get(name) {
    const cookieArray = this.cookie.split('; '); //得到分割的cookie名值对
    const cookie = {};
    for (let i = 0; i < cookieArray.length; i++) {
      const arr = cookieArray[i].split('='); //将名和值分开
      if (arr[0] === name && arr[1]) {
        return unescape(arr[1]); //如果是指定的cookie，则返回它的值
      }
    }
    return '';
  }

  remove(key) {
    // this.store.removeItem(key);
  }

  clearAll() {
    const keys = this.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (let i = 0; i < keys.length; i++ ) {
        this.cookie = keys[i] + '=0;expires=' + new Date(0).toGMTString() + ';path=/';
      }
    }
  }

}

export default new Cookie();
